import type { UseQueryResult } from '@tanstack/react-query';
import { useBffGet } from '../bff';
import { BffQueryKey } from '../model/BffQueryKey';
import type { BFFHttpError } from '../model/BFFHttpError';
import type { BFFQueryOptions } from '../model/BFFQueryOptions';
import type { Products } from './model';

interface GetProductsOptions extends BFFQueryOptions<Products> {
    returnOffline?: boolean;
    returnOnlyOrderable?: boolean;
    returnNextAvailableVariant?: boolean;
}

export const useProducts = (
    ids = [] as string[],
    options?: GetProductsOptions,
): UseQueryResult<Products, BFFHttpError> =>
    useBffGet<Products>(
        '/products',
        [
            {
                ids,
                returnOffline: !!options?.returnOffline,
                returnOnlyOrderable: !!options?.returnOnlyOrderable,
                returnNextAvailableVariant: !!options?.returnNextAvailableVariant,
            },
        ],
        [BffQueryKey.PRODUCTS, ids.join(','), JSON.stringify(options || {})],
        {
            keepPreviousData: true,
            enabled: !!options?.enabled || !!ids.length,
            retryOnMount: false,
            headers: {
                'Cache-Control': 'no-store',
            },
        },
    );
